"use strict";
import Splide from "@splidejs/splide";
import AOS from "aos";
export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const vantagensSlider = document.querySelector(
            ".o-vantagens__cards.splide"
        );
        if (!vantagensSlider) return;

        const splide = new Splide(vantagensSlider, {
            type: "loop",
            perPage: 3,
            autoplay: false,
            interval: 5000,
            speed: 800,
            drag: false,
            pauseOnHover: true,
            arrows: false,
            pagination: false,
            gap: "1.938rem",
            breakpoints: {
                1024: {
                    perPage: 2,
                    drag: true,
                    autoplay: true,
                },
                680: {
                    perPage: 1,
                },
            },
        });

        splide.mount();
        setTimeout(() => {
            AOS.refreshHard();
        }, 300);
    });
}
